import { Template, User } from 'components';
import { type PageDefinition, ROUTES } from 'consts/pages';
import { SWR_CONFIG } from 'consts/swr.config';
import { Admin, CompletionMetrics } from 'pages/admin';
import { Authenticate } from 'pages/authenticate/Authenticate';
import { Curity } from 'pages/curity/Curity';
import { Waiver } from 'pages/waiver/Waiver';
import { AppContext, BuildAppContext } from 'providers/AppContext';
import { ApplicationContext, BuildApplicationContext } from 'providers/ApplicationContext';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router';
import { SWRConfig } from 'swr';
import type { AppConfig } from 'types';

export function AppRoutes({ config }: Readonly<{ config: AppConfig }>) {
	return (
		<ApplicationContext.Provider value={BuildApplicationContext(config)}>
			<BrowserRouter>
				<Routes>
					{config.IS_EMPLOYEE_WEB && <Route element={<Element Page={Admin} path="" />} path="/admin" />}
					{config.IS_EMPLOYEE_WEB && (
						<Route element={<Element Page={CompletionMetrics} path="" />} path="/admin/completion-metrics" />
					)}
					<Route element={<Element Page={Authenticate} path="" />} path="/:flowType/authenticate" />
					<Route element={<Element Page={Curity} path="" />} path="/curity" />
					<Route element={<Element Page={Waiver} path="" />} path="/waiver-confirmation/:token?" />
					<Route path="/:flowType/:entityType">{ROUTES.map(Page)}</Route>
					<Route element={<Navigate replace={true} to="/mv/authenticate" />} path="*" />
				</Routes>
			</BrowserRouter>
		</ApplicationContext.Provider>
	);
}

function Page(props: PageDefinition) {
	return <Route element={<Element {...props} />} key={props.path} path={props.path} />;
}

function Element(props: PageDefinition) {
	const ctx = BuildAppContext();
	return (
		<SWRConfig value={{ ...SWR_CONFIG, fetcher: ctx.http.fetcher }}>
			<AppContext.Provider value={ctx}>
				<User>
					<Template>
						<props.Page />
					</Template>
				</User>
			</AppContext.Provider>
		</SWRConfig>
	);
}
